import { Component, Input } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { FormsResponsesRoutes, AdminUsersRoutes, RoutesEnum } from 'src/app/core/enums/routes.enum';
import { Privileges } from 'src/app/core/privileges/privileges';
import { UserCompetenceRequirementType } from 'src/app/shared/enums/enums';
import { CompetenceStatusEnum } from 'src/app/shared/user-view/models/competence-user.model';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';

@Component({
  selector: 'app-users-template',
  templateUrl: './users-template.component.html',
  styleUrls: ['./users-template.component.scss'],
  standalone: false,
})
export class UsersTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
  @Input() urlForRouting: string;

  adminUsersRoutes = AdminUsersRoutes;
  userCompetenceRequirementType = UserCompetenceRequirementType;
  competenceStatusEnum = CompetenceStatusEnum;
  Privileges = Privileges;
  userId = '';

  get competenceActionPrivilege(): string | string[] {
    if (this.element?.isRegistrationCompleted) {
      return this.canUseSelfAssignable ? [] : Privileges.UserCompetenceRenew;
    }

    return this.canUseSelfAssignable ? [] : Privileges.UserCompetenceCreate;
  }

  constructor(
    private router: Router,
    private store: Store
  ) {}

  routeToCustomForm(competenceId: string, formId: string): void {
    const link = FormsResponsesRoutes.List.replace(':id', competenceId);
    this.router.navigate([link], {
      queryParams: { moduleName: RoutesEnum.Users, formId },
    });
  }

  toRenewCompetence() {
    this.userId = this.getUserId(this.router.routerState.snapshot.root);
    this.router.navigateByUrl(
      `${
        this.element.isRegistrationCompleted
          ? this.adminUsersRoutes.CompetenceUserRenew
          : this.adminUsersRoutes.CompetenceUserRegister
      }${this.userId}/${this.element.competenceId}`
    );
  }

  private get canUseSelfAssignable(): boolean {
    return (
      this.element?.selfAssignable === true &&
      this.getUserId(this.router.routerState.snapshot.root) ===
        this.store.selectSnapshot(TenantUserAccessState.userAccess)?.id
    );
  }

  private getUserId(activatedRouteSnap: ActivatedRouteSnapshot): string {
    const userId = activatedRouteSnap.params.id;
    if (userId) {
      return userId;
    }

    for (const childRoute of activatedRouteSnap.children) {
      const childUserId = this.getUserId(childRoute);
      if (childUserId) {
        return childUserId;
      }
    }

    return '';
  }
}
